  
    <div class="chips-wrapper">
      <div class="content-wrapper">  
        <input  [formControl]="control"
                [(ngModel)]="listSet"
                [attr.readonly]="readonly ? '': null"
                (keydown.enter)="onOptionsSetKeydown()" 
                (blur)="onOptionsSetKeydown()" 
                type="text"
                (click)="cleanInp()" 
                class="form-control form-control--paybee chips"
                #chips
                id="{{idChips}}"
                autocomplete="off"
        />
        <label mdbLabel for="{{idChips}}" class="form-label form-label--paybee" [ngStyle]="required && control.touched && list.length < 1 && {'color': 'red'} || null">{{placeholder}}</label> 
        <div  class="form-fill-error error-chips"  *ngIf="required && control.touched && list.length < 1">Please add Tags</div>
      </div>  
      <div class="chips-list"
      [ngClass]="{
        'read-only': readonly,
      }">  
          <div *ngFor="let item of list; let i = index" class="chips-item">  
            <span> {{item}} </span>
            <app-icon-delete-chips (click)="dropOption(i)"></app-icon-delete-chips>
          </div> 
      </div>  
    </div>  